/**
 * TrustBar — MADE-260
 *
 * Four trust signals — copy is LOCKED by Skip:
 *   Established 1992 · Made in Barbados · Marine-grade materials · DHL delivery
 *
 * No variations. No "Founded 1992". No "30+ years".
 */

import { Box, Container, Typography } from '@mui/material';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PlaceIcon from '@mui/icons-material/Place';
import WaterIcon from '@mui/icons-material/Water';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

export function TrustBar() {
  return (
    <Box
      component="section"
      aria-label="Trust signals"
      sx={{
        backgroundColor: '#fafbff',
        borderTop: '1px solid rgba(102,126,234,0.12)',
        borderBottom: '1px solid rgba(102,126,234,0.12)',
        py: { xs: 5, md: 6 },
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: { xs: 4, sm: 5, md: 8 },
            alignItems: 'center',
          }}
        >
          {/* Established 1992 */}
          <Box
            data-testid="trust-established"
            sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
          >
            <EventAvailableIcon sx={{ color: '#667eea', fontSize: '1.6rem', flexShrink: 0 }} />
            <Typography
              variant="body1"
              sx={{
                color: '#2c3e50',
                fontWeight: 600,
                fontSize: { xs: '0.9rem', md: '1rem' },
                whiteSpace: 'nowrap',
              }}
            >
              Established 1992
            </Typography>
          </Box>

          {/* Made in Barbados */}
          <Box
            data-testid="trust-barbados"
            sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
          >
            <PlaceIcon sx={{ color: '#667eea', fontSize: '1.6rem', flexShrink: 0 }} />
            <Typography
              variant="body1"
              sx={{
                color: '#2c3e50',
                fontWeight: 600,
                fontSize: { xs: '0.9rem', md: '1rem' },
                whiteSpace: 'nowrap',
              }}
            >
              Made in Barbados
            </Typography>
          </Box>

          {/* Marine-grade materials */}
          <Box
            data-testid="trust-marine"
            sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
          >
            <WaterIcon sx={{ color: '#667eea', fontSize: '1.6rem', flexShrink: 0 }} />
            <Typography
              variant="body1"
              sx={{
                color: '#2c3e50',
                fontWeight: 600,
                fontSize: { xs: '0.9rem', md: '1rem' },
                whiteSpace: 'nowrap',
              }}
            >
              Marine-grade materials
            </Typography>
          </Box>

          {/* DHL delivery */}
          <Box
            data-testid="trust-dhl"
            sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
          >
            <LocalShippingIcon sx={{ color: '#667eea', fontSize: '1.6rem', flexShrink: 0 }} />
            <Typography
              variant="body1"
              sx={{
                color: '#2c3e50',
                fontWeight: 600,
                fontSize: { xs: '0.9rem', md: '1rem' },
                whiteSpace: 'nowrap',
              }}
            >
              DHL delivery
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
